<template>
  <div class="abiturient-layout grey lighten-3">
    <Header />
    <v-container class="pt-5 pb-5">
      <main class="abiturient-layout__main" style="min-height: 60vh;">
        <router-view :key="$route.fullPath" />
      </main>
    </v-container>

    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/abiturient/Header.vue'
  import Footer from '@/components/abiturient/Footer.vue'
  export default {
    components: {
      Header,
      Footer
    },
    mounted() {
      

    },
    computed: {
      selectedLanguage() {
        return this.$store.getters.getLanguage;
      }
    },
    data: () => ({
      languages: {
        'kk': 'Қазақша',
        'ru': 'Русский',
        'en': 'English'
      }
    }),
    methods: {
      changeLanguage(lang) {
        this.$store.dispatch('changeLanguage', lang);
      },
      logout() {
        this.$store.dispatch('logout');
      }
    }
  }
</script>

<style>
  @media (min-width: 1904px) {
    .container {
      max-width: 1140px !important;
    }
  }
  
</style>